import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ClientServiceService } from '../services/client-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-blog-info',
  templateUrl: './blog-info.component.html',
  styleUrls: ['./blog-info.component.css']
})
export class BlogInfoComponent implements OnInit {

  post_url: string = "";

  post: any = null;

  constructor(
    private client_service: ClientServiceService,
    private router: Router,
    private activRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.post_url = this.activRoute.snapshot.paramMap.get('post_url') as string;
    this.get_blog_info();
  }

  get_blog_info() {
    this.client_service.get_blog_info(this.post_url).subscribe({
      next: (data) => {
        this.post = data;
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  handleImageError(): void {
    this.post.url_img = 'assets/img/bg2.png';
  }
}
